import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {FooterState} from './FooterState.interface';

const INITIAL_FOOTER_STATE: FooterState = {
  mobile: {
    isExposed: undefined,
  },
};

export const footerSlice = createSlice({
  name: 'footer',
  initialState: INITIAL_FOOTER_STATE,
  reducers: {
    setFooter: (state, action: PayloadAction<FooterState>): void => {
      Object.assign(state, {...action.payload});
    },
    initializeFooter: (state): void => {
      Object.assign(state, {...INITIAL_FOOTER_STATE});
    },
  },
});

export const {setFooter, initializeFooter} = footerSlice.actions;
